import { Component,  Input } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { CommonModule } from '@angular/common';
@Component({
    selector: 'icon-text',
    template: `
<div class="holder smooth" [ngClass]="{ active: active }">
  <icon class="icon" *ngIf="!!icon" [icon]="icon" ></icon>
  <div class="text ellipsis" *ngIf="!!text">{{ text }}</div>
</div>
`,
    styleUrls: ['./icon-text.scss'],
    imports: [IconComponent, CommonModule],
    standalone: true
})

export class IconTextComponent {
  @Input() icon = "filter"
  @Input() text
  @Input() active = false
}

